import { Component, OnInit, SecurityContext, inject, input } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { ImageCroppedEvent, LoadedImage, ImageCropperComponent } from 'ngx-image-cropper';
import { ToastrService } from 'ngx-toastr';


@Component({
    selector: 'app-image-upload-modal',
    templateUrl: './image-upload-modal.component.html',
    styleUrl: './image-upload-modal.component.scss',
    imports: [ImageCropperComponent, TranslatePipe]
})
export class ImageUploadModalComponent implements OnInit {
  private sanitizer = inject(DomSanitizer);
  private modal = inject(NgbActiveModal);
  private toastr = inject(ToastrService);
  private translate = inject(TranslateService);


  readonly width = input<number>(1920);
  readonly height = input<number>(1080);
  readonly maintainAspectRatio = input<boolean>(true);
  readonly imageName = input<string>('image');
  readonly outputFormat = input<string>('jpg');
  aspectRatio = 1;
  


  imageChangedEvent: Event | null = null;
  croppedImage: SafeUrl = '';
  showCropper: boolean = true;
  showPreview: boolean = false;
  maxFileSizeBytes = 10 * 1024 * 1024;

  ngOnInit(): void {
    if (this.width() > 0 && this.height() > 0) {
      this.aspectRatio = this.width() / this.height();
    }
  }

  fileChangeEvent(event: Event): void {
    if (!(event.target instanceof HTMLInputElement)) { return; }
    const target = event.target as HTMLInputElement;
    if (!target?.files || !(target.files instanceof FileList)) { return; }
    const files = target.files as FileList;
    if (!files || files.length < 1) {
      this.showPreview = false;
      this.showCropper = false;
      this.imageChangedEvent = null;
    } else if (files[0].size > this.maxFileSizeBytes) {
      this.showPreview = false;
      this.showCropper = false;
      this.imageChangedEvent = null;
    } else {
      this.showCropper = true;
      this.imageChangedEvent = event;
    }

  }
  imageCropped(event: ImageCroppedEvent) {
    if (event.base64) {
      this.croppedImage = this.sanitizer.sanitize(SecurityContext.URL,event.base64);
    }
    else {
      this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
    }
  }
  imageLoaded(image: LoadedImage) {
    console.log('loaded', image);
    this.showPreview = true;
  }
  cropperReady() {
    console.log('ready');
  }
  loadImageFailed() {
    console.log('failed');
    this.showPreview = false;
  }

  closeModal() {
    this.modal.close();
  }

  save() {
    const base64 = this.sanitizer.sanitize(SecurityContext.URL, this.croppedImage);
    const base64str = base64.split('base64,')[1];
    const decoded = atob(base64str);
    const size = decoded.length;
    if (size > 1024 * 1024 * 5) {
      this.toastr.error(this.translate.instant('ImageUpload.TooLargeMessage', { maxSize: '5MB' }), this.translate.instant('ImageUpload.TooLarge'))
      return;
    }
    this.modal.close(this.croppedImage);
  }

}
